// @flow

import type { Media, MediaGallery } from '../types/keepeekType';

export const getMediaByGallery = (mediaList: MediaGallery[], galleryLabel: string): Media[] => {
  const gallery = mediaList.filter(mediaGallery => mediaGallery.gallery === galleryLabel)[0];
  return gallery ? gallery.medias : [];
};

export const galleriesHaveMedias = (
  galleries: string[],
  mediaGalleries: MediaGallery[],
): boolean => mediaGalleries.some((gallery: MediaGallery) => galleries.includes(gallery.gallery));

export const ACCESS_PLAN = 'Access Plan';
export const ARCHIVE = 'Archive';
export const AWARDS = 'Awards';
export const BEST_OF = 'Best of';
export const BRAND_EVENT = 'Brand Event';
export const BROCHURE_PLAN = 'Brochure Plan';
export const BROCHURES = 'Brochures';
export const CATCHMENT_AREA_MAPS = 'Catchment Area Maps';
export const CEO = 'CEO';
export const CFO = 'CFO';
export const CODE_OF_ETHICS = 'Code of Ethics';
export const COMMUNICATION_VISUALS = 'Communication Visuals';
export const CORPORATE_BROCHURES = 'Corporate Brochures';
export const CORPORATE_VIDEOS = 'Corporate Videos';
export const COUNTRIES_BROCHURES = 'Countries Brochures';
export const COUNTRIES_VIDEOS = 'Countries Videos';
export const DESTINATION = 'Destination';
export const EVENTS = 'Events';
export const EXTERIOR = 'Exterior';
export const ICONIC_SHOP_FRONT = 'Iconic Shop Fronts';
export const INNOVATION = 'Innovation';
export const INTERIOR = 'Interior';
export const KEY_ASSET = 'Key Assets';
export const KEY_ASSET_LOGO = 'Key Assets logo';
export const KEY_ASSET_MAIN_IMAGE = 'Key Assets main image';
export const LEASING_PLAN = 'Leasing Plan';
export const LOGO = 'Logo';
export const MANAGER_PICTURE = 'Manager Picture';
export const PIPLINE_PROJECTS = 'Pipeline projects';
export const PROJECT_PLAN = 'Project Plan';
export const PROJECTS = 'Projects';
export const RENTAL_SPACE = 'Rental Space';
export const SENIOR_MANAGEMENT_TEAM = 'Senior Management Team';
export const SPHERICAL_OLD_FORMAT = 'Spherical old format';
export const SUPERVISORY_BOARD = 'Supervisory Board';
export const SUPERVISORY_CHAIRMAN = 'Supervisory Chairman';
export const URDNA_INNOVATION = 'URDNA Innovation';
export const URDNA_DESTINATION = 'URDNA Destination';
export const VIRTUAL_VISITS = 'Virtual Visits';
export const VIDEO = 'Video';
